import React, { useCallback, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { Creators as CarouselItemCreators } from 'store/products/products-duck.js';
import ProductPreview from 'components/product-preview';
import { Box, Typography, IconButton } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const HighLightedSession = ({ highlightedProducts, productsFetchHighlightedAsync }) => {
  const scrollRef = useRef();

  const fetch = useCallback(() => {
    productsFetchHighlightedAsync();
  }, [productsFetchHighlightedAsync]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  const scrollLeft = () => {
    scrollRef.current.scrollBy({ left: -300, behavior: 'smooth' });
  };

  const scrollRight = () => {
    scrollRef.current.scrollBy({ left: 300, behavior: 'smooth' });
  };

  if (highlightedProducts.length === 0) return null;

  return (
    <Box sx={{ mt: 4 }}>
      <Typography
        variant="h5"
        sx={{
          color: '#92b21f',
          fontWeight: 'bold',
          textTransform: 'uppercase',
          mb: 2,
          textShadow: '0 0 8px rgba(146, 178, 31, 0.6)',
        }}
      >
        Produtos em destaque
      </Typography>

      <Box sx={{ position: 'relative', overflow: 'visible' }}>
        <IconButton
          onClick={scrollLeft}
          sx={{
            position: 'absolute',
            top: '50%',
            left: 8,
            transform: 'translateY(-50%)',
            zIndex: 2,
            backgroundColor: 'black',
            color: '#92b21f',
            '&:hover': { backgroundColor: '#222' },
          }}
        >
          <ChevronLeftIcon fontSize="large" />
        </IconButton>

        <Box
          ref={scrollRef}
          sx={{
            display: 'flex',
            gap: { xs: 1, sm: 2 },
            overflowX: 'auto',
            scrollBehavior: 'smooth',
            px: 4,
            py: 1,
            '&::-webkit-scrollbar': { display: 'none' },
          }}
        >
          {highlightedProducts.map((item) => (
            <ProductPreview product={item} key={item.id} />
          ))}
        </Box>

        <IconButton
          onClick={scrollRight}
          sx={{
            position: 'absolute',
            top: '50%',
            right: 8,
            transform: 'translateY(-50%)',
            zIndex: 2,
            backgroundColor: 'black',
            color: '#92b21f',
            '&:hover': { backgroundColor: '#222' },
          }}
        >
          <ChevronRightIcon fontSize="large" />
        </IconButton>
      </Box>
    </Box>
  );
};

const mapStateToProps = (state) => ({
  highlightedProducts: state.Product.highlightedProducts,
});

const mapDispatchToProps = (dispatch) => bindActionCreators(CarouselItemCreators, dispatch);

HighLightedSession.propTypes = {
  highlightedProducts: PropTypes.array.isRequired,
  productsFetchHighlightedAsync: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(HighLightedSession);
